var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:[_vm.activeClass,_vm.directionClass],on:{"click":function($event){return _vm.changeOrder()}}},[_vm._t("default"),_c('span',{staticClass:"direction"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }